import React, { useState } from 'react';
import { Banner } from '@cad-arc';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { useApplicationType } from '../common/hooks/use-application-type';

const CUTOFF_DATE_LABEL = 'July 31, 2026';

/**
 * Yellow banner pinned under the top nav warning users running a legacy or
 * below-minimum-supported client that their app is at risk of deprecation. Trigger
 * is sourced entirely from the backend via `parsedClientApp.outOfDate` on the
 * `/bootstrap/cad_next` response; the FE just consumes it.
 *
 * Dismiss is per-session — `useState` only, no localStorage — so the warning
 * resurfaces if the user reopens the app without upgrading.
 */
export function DeprecationBanner(): React.ReactElement | null {
    const { parsedClientApp } = useBootstrapState();
    const { isFirstResponder } = useApplicationType();
    const [dismissed, setDismissed] = useState(false);


    if (!parsedClientApp?.outOfDate || dismissed) {
        return null;
    }

    const appLabel = isFirstResponder ? 'Mark43 First Responder' : 'Mark43 CAD';
    const description = (
        <>
            You&rsquo;re using {appLabel} version {parsedClientApp.version} that will no longer
            be supported after <strong>{CUTOFF_DATE_LABEL}</strong>. Please contact your
            agency&rsquo;s IT for assistance in updating to the latest version
        </>
    );

    return (
        <Banner
            status="attention"
            title="Upgrade Required Soon"
            description={description}
            onClose={() => setDismissed(true)}
        />
    );
}
